var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('header',{staticClass:"navbar-change-account__container"},[_c('LogoIcon')],1)}
var staticRenderFns = []

export { render, staticRenderFns }